module.exports = __webpack_public_path__ + "ClientApp/images/inquiry.png";